import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api_url } from "../helpers";
import { userContext } from "../context/UserContext";
import { toast } from "react-toastify";

const Account = () => {
  const { setUser, setLoad } = useContext(userContext);
  const [username, setUsername] = useState("");
  const [password, setpassword] = useState("");
  const navigate = useNavigate();

  async function HandleLogin(e) {
    e.preventDefault();

    setLoad(true);

    try {
      const response = await fetch(
        api_url +
          `method/erp_sn.api.authentication.login?usr=${username}&pwd=${password}`,
        { method: "POST" }
      );

      if (response.ok == true) {
        const data = await response.json();

        if(data?.message?.success_key == 0){
          toast.error("Incorrect Credentials")
          setLoad(false)
        }else{
          setUser({
            name: data?.full_name,
            api_key: data?.message?.api_key,
            api_secret: data?.message?.api_secret,
            email: data?.message?.email,
            customer_id: data?.message?.customer_id,
          });
  
          toast.success("User logged in successfully!");
  
          
  
          setTimeout(() => {
            window.location.pathname = '/'
            setLoad(false);
          }, 300);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <section className="account py-80">
      <div className="container container-lg ">
        <form onSubmit={(e) => HandleLogin(e)}>
          <div className="row gy-4 justify-content-center">
            {/* Login Card Start */}
            <div className="col-xl-6 pe-xl-5">
              <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
                <h6 className="text-xl mb-32">Login</h6>
                <div className="mb-24">
                  <label
                    htmlFor="username"
                    className="text-neutral-900 text-lg mb-8 fw-medium"
                  >
                    Email address <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="email"
                    className="common-input"
                    required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    id="username"
                    placeholder="First Name"
                  />
                </div>
                <div className="mb-24">
                  <label
                    htmlFor="password"
                    className="text-neutral-900 text-lg mb-8 fw-medium"
                  >
                    Password
                  </label>
                  <div className="position-relative">
                    <input
                      type="password"
                      className="common-input"
                      id="password"
                      placeholder="Enter Password"
                      defaultValue="password"
                      required
                      value={password}
                      onChange={(e) => setpassword(e.target.value)}
                    />
                    <span
                      className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ph-eye-slash"
                      id="#password"
                    />
                  </div>
                </div>
                <div className="mb-24 mt-48">
                  <div className="flex-align gap-48 flex-wrap">
                    <button type="submit" className="btn btn-main py-18 px-40">
                      Log in
                    </button>
                    <div className="form-check common-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        defaultValue=""
                        id="remember"
                      />
                      <label
                        className="form-check-label flex-grow-1"
                        htmlFor="remember"
                      >
                        Remember me
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mt-48">
                  <Link
                    to="#"
                    className="text-danger-600 text-sm fw-semibold hover-text-decoration-underline"
                  >
                    Forgot your password?
                  </Link>
                </div>
              </div>
            </div>

            {/* Register Card End */}
          </div>
        </form>
      </div>
    </section>
  );
};

export default Account;
